/**
 * Internal dependencies
 */
import { getHTMLFormatters } from '../../../richText/htmlManipulation';

function getElementWideFontUpdate({ content = '' }, font) {
  const { setFontReference } = getHTMLFormatters();
  return {
    font,
    figmaFontName: null,
    content: setFontReference(content, null),
    fontReferences: undefined,
  };
}

export default getElementWideFontUpdate;
